<script setup>
import {onMounted, onUnmounted, ref} from "vue";

const emit = defineEmits(['step', 'select']);
const {subscriptions, value} = defineProps(['subscriptions', 'value']);

const subscription = ref(value);

function select(new_value) {
    subscription.value = new_value;
    emit('select', new_value);
}

function next() {
    switch ( subscription.value ) {
        case 'dance_pass':
            emit('step', 'dances-courses');
            break;
        case 'limited_pass':
        case 'session_pass':
            emit('step', 'account');
            break;
        case 'fitness_pass':
            emit('step', 'period');
            break;
        case 'special_pass':
            emit('step', 'special-formulas');
            break;
    }
}

const computeHeights = () => {
    let sameHeightsValues = {};
    let sameHeights = document.querySelectorAll("[data-same-height]");

    sameHeightsValues = {};

    sameHeights.forEach( el => {
        el.style.removeProperty('height');

        const group = el.getAttribute('data-same-height');

        if ( !sameHeightsValues[ group ] ) {
            sameHeightsValues[ group ] = 0;
        }

        let height = el.offsetHeight;

        if ( height > sameHeightsValues[ group ] ) {
            sameHeightsValues[ group ] = height;
        }
    } );

    sameHeights.forEach( el => {
        const group = el.getAttribute('data-same-height');
        const minWidth = el.getAttribute('data-same-height-min-width') || 0;

        if ( parseInt( minWidth ) <= window.innerWidth ) {
            el.style.height = sameHeightsValues[ group ] + "px";
        }
    } );
};

onMounted( () => {
    computeHeights();
    window.addEventListener('resize', computeHeights );

    setTimeout( () => computeHeights(), 400 );
} );

onUnmounted( () => {
    window.removeEventListener('resize', computeHeights );
} );

</script>

<template>
    <div class="w-full flex flex-col">
        <div class="flex flex-row mb-10">
            <h2 class="text-white text-4xl text-center flex-1">Type d'abonnement</h2>
        </div>

        <div class="overflow-scroll mb-10">
            <div class="flex flex-row gap-x-5 w-[300vw] sm:w-[250vw] lg:w-[150vw] xl:w-[100vw] 2xl:w-full">
                <div v-for="item in subscriptions"
                    class="subscription-type | flex flex-col flex-1 p-5 text-white border transition-colors bg-dark border-dance rounded-2xl"
                    :class="{
                        'bg-zinc-500/20': subscription === item.subscription_type,
                        'border-dance': item.course_type === 'dance',
                        'border-fitness': item.course_type === 'fitness',
                        'border-purple': item.course_type === 'both',
                    }"
                >
                    <h3 class="font-bold text-2xl mb-2" :class="{
                        'text-dance': item.course_type === 'dance',
                        'text-fitness': item.course_type === 'fitness',
                        'text-purple': item.course_type === 'both',
                        }" v-html="item.title" data-same-height="title"></h3>
                    <div class="text-lg font-bold mb-2" data-same-height="price"
                         v-if="item.subscription_type === 'dance_pass' || item.subscription_type === 'fitness_pass' || item.subscription_type === 'special_pass'">
                        à partir de {{ item.prices[0] }} &euro; {{ item.price_detail }}
                    </div>
                    <div class="text-lg font-bold mb-2" data-same-height="price" v-else>{{ item.price }} &euro; {{ item.price_detail }}</div>
                    <div class="border-b border-purple pb-2 mb-5" v-if="item.course_type === 'both'">Danse et fitness</div>
                    <div class="border-b border-dance pb-2 mb-5" v-if="item.course_type === 'dance'">Danse uniquement</div>
                    <div class="border-b border-fitness pb-2 mb-5" v-if="item.course_type === 'fitness'">Fitness uniquement</div>

                    <ul class="mb-5 flex flex-col gap-y-2" data-same-height="details">
                        <li v-for="detail in item.details"><i class="fa-fw fa-solid fa-check" :class="{
                        'text-dance': item.course_type === 'dance',
                        'text-fitness': item.course_type === 'fitness',
                        'text-purple': item.course_type === 'both',
                        }"></i> {{ detail }}</li>
                    </ul>

                    <button :class="{
                        'button-invert': subscription !== item.subscription_type,
                        'button': subscription === item.subscription_type,
                    }" class="px-5 py-2" type="button" title="Sélectionner" aria-label="Sélectionner"
                            @click="select(item.subscription_type)">Sélectionner</button>
                </div>
            </div>
        </div>

        <div class="text-center">
            <button class="button px-5 py-3" type="button" title="Suivant" @click="next" :disabled="!subscription">Suivant <i class="fa-solid fa-angle-right | ml-2"></i></button>
        </div>
    </div>
</template>